




































































































































import { Component } from 'vue-property-decorator';
import { RepairOrderPagedListModel, VHeaders } from '@/models/pagedlistmodel';
import {
  CustomerUpdateViewModel,
  RepairOrderViewModel,
} from '@/models/fixedops/repairorder';
import { PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { repairOrderService, teamService, laneService, paymentService, depositLogService } from '@/shared';
import { RoleType } from '@/helper/enum';
import { IDialogOption } from '@/models/dialog';
import { Lane } from '@/models/admin/lane';
import { Utils } from '@/helper/utils';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    OpenRepairOrderGrid: () =>
      import('@/components/repairorder/openrepairorder.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
  },
})
class RepairOrderListPage extends Base {
  public errors: any;
  public pagedRepairOrders: RepairOrderPagedListModel<any> = {
    isAdvisorRole: false,
    isMessagingEnabled: false,
    showCallDetails: false,
    storeLogo: '',
    storeName: '',
    results: [],
  };
  public paymentDialog: boolean = false;
  public fileBunkerLoading: boolean = false;
  public customerUpdateViewModel: CustomerUpdateViewModel = {
    cellPhone: '',
    businessPhone: '',
    phoneNumber: '',
    customerNumber: '',
    firstName: '',
    lastName: '',
  };
  public isShowWarning: boolean = false;
  public warningMessage = '';
  public pagination = new PaginationModel('repairOrderNumber');
   public currentRoutePagination = new PaginationModel('repairOrderNumber');
  public loading: boolean = false;
  public teamLoading: boolean = false;
  public actions: any[] = [];
  public storeTeams: any[] = [];
  public lane: string = '';
  public storeId: number = 0;
  public paymentProvider: string = '';
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeName: string = '';
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public currentUrl: string = '';

  public roDetails: RepairOrderViewModel = {};

  public roNumber = '';
  public preventPaginationCall: boolean = false;
  public isAmountOverride: boolean = false;
  public isSendPaymentReceipt: boolean = true;
  public fileRef: any;
  public filters: string = '';
  public selectedFilter = [];
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
  };

  public constants: any = {
    roNumber: '',
    laneId: 0,
  };

  public isLaneLoading: boolean = false;

  public paymentActions: any[] = [];
  public lanes: Lane[] = [];
  public getSelectedLaneList: any = [];

  public blockInvalidKeys(e: KeyboardEvent) {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  }


  public closeRoPaymentDetail: any = {
    amountToBePaid: '',
    paymentMode: '',
    amountPaid: '',
    paymentType: '',
    isAmountOverride: false,
    isSendPaymentReceipt: true
  };
  public amountToBePaid: string = '';
  public paymentMode: string = '';
  public amountPaid: string = '';
  public paymentType: string = '';

  public childMethodName: string = '';
  public childProgress: boolean = false;
  public squareDialog: boolean = false;
  public cenposDialog: boolean = false;
  public isCloverDialog: boolean = false;
  public isCloverConfigured: boolean = false;
  public isBypassCreditCardFeeRole: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public bypassReason: string = "";
  public isTerminalPaymentEnabled: boolean = false;
  public fileBunkerProcessItems: any[] = [];
  public fileBunkerProcessHeaders: VHeaders[] = [
    {
      text: "FileName",
      align: 'left',
      value: 'fileName',
      sortable: true,
    },
    {
      text: "Started At",
      align: 'left',
      value: 'createdAt',
      fieldType: 'date',
      sortable: true,
    }
  ];

  public paymentAmountDialog: IDialogOption = {
    width: 500,
    title: 'Run Card Payment',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: 'Process Payment',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.setDetails();
    },
  };



  public fileProgressDialog: IDialogOption = {
    width: 800,
    title: 'RO Attachments upload in progress',
    model: false,
    loading: false,
  };

  public async openFileBunkerDialog() {
    try {
      this.fileBunkerLoading = true;
      var response = await repairOrderService.getFileBunkerProcess();
      this.fileBunkerProcessItems = response;

    } finally {
      this.fileBunkerLoading = false;
    }

  }


  public selectLanePopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.selectLaneDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'repairOrderDetails.selectLaneDialog.btnPay'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeVantivPayment();
    },
  };

  public manualPaymentPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderDetails.manualPaymentDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderDetails.manualPaymentDialog.agree'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.payManually();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'search') {
      this.search();
    }
    if (methodName !== '' && methodName === 'search') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public resetMethodName(methodName): void {
    this.$emit('resetMethodName', methodName);
  }

  public payOldRo(): void {
    this.paymentAmountDialog.model = true;
  }

  public updateCenposDialog(cenposDialogValue) {
    this.cenposDialog = cenposDialogValue;
  }

  public setDetails() {
    if (this.validateForm()) {
      if (
        this.closeRoPaymentDetail.paymentType != '' &&
        this.closeRoPaymentDetail.paymentType != undefined
      ) {
        this.getRoDetail(this.closeRoPaymentDetail.roNumber);
      } else {
        return;
      }
    }
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  // VANTIV TERMINAL PAYMENT
  public async makeVantivPayment(): Promise<void> {
    const amount = this.closeRoPaymentDetail.amountToBePaid;
    try {

      if (Number(amount) === 0 || isNaN(Number(amount))) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertDueAmountIsZero')
        );
        return;
      }
      if (!this.lane) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertPleaseSelectLane')
        );
        return;
      }
      this.selectLanePopup.action.disable = true;
      this.selectLanePopup.loading = true;
      this.roDetails.displayDueAmount = this.closeRoPaymentDetail.amountToBePaid;
      this.roDetails.isAmountOverride = this.isAmountOverride;
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await repairOrderService.makeVantivPayment(
        this.roDetails,
        this.lane,
        false,
        true,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );

      this.roDetails.displayDueAmount = amount;
      var isInProcess = false;
      var isFailed = false;
      var isApproved = false;
      //For Payroc payments, the payment status is updated via a web job, so there's no need to check the payment status repeatedly
      if (this.roDetails.defaultPaymentProvider != 'Payroc') {
        for (var i = 0; i <= 3; i++) {
          await new Promise((resolve) => setTimeout(resolve, 15000)); // 3 sec
          const paymentResponse = await paymentService.getPaymentDetailStatus(
            response.transactionHeaderId,
            response.transactionDetailId
          );

          if (paymentResponse.status == 'Approved') {
            isApproved = true;
            break;
          }
        }
      } else {
        const paymentResponse = await paymentService.getPaymentDetailStatus(
          response.transactionHeaderId,
          response.transactionDetailId
        );
        if (paymentResponse.status == "InProcess") {
          isInProcess = true;
        }
        else if (paymentResponse.status == "Failed") {
          isFailed = true;
        }
      }
      this.isShowWarning = true;
      if (isFailed) {
        this.selectLanePopup.model = false;
        this.showAlert(false, "Payment Failed. Please Try Again");
      }
      else if (isInProcess) {
        this.warningMessage = "Payment Created Successfully, Please check the final status in Payment report.";
      }
      else if (isApproved) {
        this.warningMessage = "Payment is Approved Successfully.";
        this.showAlert(true, "Payment is Approved Successfully.");
      }
      else {
        this.warningMessage = "Approving Payment callback taking a longer time, Please check the payment final status in Payment report.";
      }
      // this.showAlert(true, response.responseMessage);
    } catch {
      this.roDetails.displayDueAmount = amount;
      this.selectLanePopup.model = false;
      this.selectLanePopup.loading = false;
    } finally {
      this.selectLanePopup.action.disable = true;
      this.selectLanePopup.loading = false;
      this.bypassReason = "";
    }
  }

  public async payManually(): Promise<void> {
    if (
      Number(this.closeRoPaymentDetail.amountToBePaid) === 0 ||
      isNaN(Number(this.closeRoPaymentDetail.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }
    // copy amountToBePaid to displayDue
    const amount = this.closeRoPaymentDetail.amountToBePaid;
    try {
      this.manualPaymentPopup.action.disable = true;
      this.manualPaymentPopup.loading = true;
      this.roDetails.displayDueAmount = this.closeRoPaymentDetail.amountToBePaid;
      this.roDetails.isAmountOverride = this.isAmountOverride;
      this.roDetails.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await repairOrderService.payManually(this.roDetails, false);
      location.href = response.redirectUri;
    } catch (e) {
      this.roDetails.displayDueAmount = amount;
    } finally {
      this.manualPaymentPopup.action.disable = false;
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
    }
  }

  public confirmPaymentDialog() {
    try {
      let amount = '0.00';
      amount = this.closeRoPaymentDetail.amountToBePaid;
      // get amountToBePaid

      if (!amount && Number(amount) <= 0) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldGreaterThanZeroAndValid')
        );
        return;
      }

      if (
        Number(amount) > Number(this.roDetails.displayDueAmount) &&
        !this.isAmountOverride
      ) {
        this.showAlert(
          false,
          this.$t('repairOrderDetails.alertAmountShouldLessThanTotalDue')
        );
        return;
      }

      if (!this.isOverrideCCFeeApplied && this.bypassReason == "") {

        this.showAlert(
          false,
          'The Bypass Reason field is required'
        );
        return;

      }

      this.paymentAmountDialog.model = false;
      // show modal popup
      switch (this.closeRoPaymentDetail.paymentType) {
        case 'rdTerminal':
          this.payWithVantivTerminal();
          break;
        case 'rdManual':
          if (
            Number(this.closeRoPaymentDetail.amountToBePaid) === 0 ||
            isNaN(Number(this.closeRoPaymentDetail.amountToBePaid))
          ) {
            this.showAlert(
              false,
              this.$t('repairOrderDetails.alertDueAmountIsZero')
            );
            return;
          }

          if (this.roDetails.defaultPaymentProvider == 'Vantiv') {
            this.manualPaymentPopup.model = true;
          } else if (this.roDetails.defaultPaymentProvider == 'Cenpos') {
            if (this.roDetails.isCenposConfigured) {
              const validateMessage = this.validateWebPayment();
              if (validateMessage == '') {
                this.paymentDialog = true;
                this.$root.$emit('validatePaymentProvider');
              } else {
                const message =
                  this.$t('openRo.paymentValidationTxt') +
                  validateMessage +
                  this.$t('openRo.paymentEmptyTxt');
                this.showAlert(false, message);
              }
            } else {
              this.showAlert(false, this.$t('stores.cenpos.alertCeponsConfig'));
            }
          }
          else {
            this.paymentDialog = true;
            this.$root.$emit('validatePaymentProvider');
          }
          break;
        default:
          break;
      }
      this.closeRoPaymentDetail.paymentMode = '';
    } finally {
      this.paymentAmountDialog.action.disable = false;
      this.paymentAmountDialog.loading = false;
    }
  }

  public payWithVantivTerminal(): void {
    if (
      Number(this.closeRoPaymentDetail.amountToBePaid) === 0 ||
      isNaN(Number(this.closeRoPaymentDetail.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('repairOrderDetails.alertDueAmountIsZero'));
      return;
    }

    this.findLanes(true);
  }

  public validateWebPayment(): string {
    let message = '';
    if (
      this.roDetails.customerCity == undefined ||
      this.roDetails.customerCity == ''
    ) {
      message += ' City';
    }

    if (
      this.roDetails.customerKey == undefined ||
      this.roDetails.customerKey == ''
    ) {
      message += ' CustomerKey';
    }

    if (
      this.roDetails.customerState == undefined ||
      this.roDetails.customerState == ''
    ) {
      message += ' State';
    }

    if (
      this.roDetails.customerStreetAddress1 == undefined &&
      this.roDetails.customerStreetAddress1 == ''
    ) {
      message += ' Address';
    }

    return message;
  }

  public async findLanes(openLanePopUp: boolean = false): Promise<void> {
    if (openLanePopUp) {
      this.selectLanePopup.model = true;
      if (this.lanes.length === 0) {
        await this.getLanes();
      }
    }
  }

  public fixDecimalValue(value) {
    if (this.closeRoPaymentDetail.amountToBePaid) {
      const amount = Number(this.closeRoPaymentDetail.amountToBePaid);
      const val = amount.toFixed(2);
      this.closeRoPaymentDetail.amountToBePaid = val;
    } else {
      this.closeRoPaymentDetail.amountToBePaid = undefined;
    }
  }

  public updateChildToolBar(buttons): void {
    if (this.flags.showForm) {
      this.updateToolBar(buttons);
    } else {
      this.updateToolBar(null);
    }
  }

  public updateToolBar(additionalButtons): void {
    let buttons: any = [];
    if (additionalButtons) {
      buttons = buttons.concat(additionalButtons);
    }
    this.$emit('updateToolBar', buttons);
  }

  public async mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'openRo');

    this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      this.childMethodName = newVal;
      this.callMethod(newVal);
    });
    this.$watch('childProgress', (newVal, oldVal) => {
      this.$emit('update:progress', newVal);
    });
    this.$watch(
      "roDetails",
      (newVal) => {
        this.paymentOptions.customerKey = newVal.customerKey;
        this.paymentOptions.vin = newVal.vin;
        this.paymentOptions.address = newVal.customerStreetAddress1 + ' ' + newVal.customerStreetAddress2;
        this.paymentOptions.city = newVal.customerCity;
        this.paymentOptions.state = newVal.customerState;
        this.paymentOptions.zipcode = newVal.customerZip;
        this.paymentOptions.customerEmail = newVal.customerEmail;
        this.paymentOptions.merchantEmail = newVal.merchantEmail;
        this.paymentOptions.recordKey = newVal.roNumber;
      },
      {
        deep: true, // Enables deep watching
      }
    );

    this.$watch('closeRoPaymentDetail.amountToBePaid', (newVal) => {
      this.paymentOptions.amount = Number(newVal);
    });

    this.$watch('isAmountOverride', (newVal) => {
      this.paymentOptions.isAmountOverride = newVal;
    });

    this.$watch('isSendPaymentReceipt', (newVal) => {
      this.paymentOptions.isSendPaymentReceipt = newVal;
    });
    this.$watch('isOverrideCCFeeApplied', (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });
    this.$watch('bypassReason', (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });
    if (this.$route.query['filters']) {
      this.selectedFilter = this.$route.query['filters'] as any;
      this.filters = this.selectedFilter as any;
    }
    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isBypassCreditCardFeeRole = isRoleAllowed.includes(role[0]);
    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.currentRoutePagination = pagination;
    }
    await this.getDefaultPaymentType();

    this.getopenOrders();

    this.currentUrl = window.location.href;
    this.getStoreTeams();
  }

  public search(): void {
    this.filters = this.selectedFilter.join(',');
    const queryStringObj = Object.assign({}, this.pagination) as any;
    if (queryStringObj) {
      queryStringObj.filters = this.filters;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getopenOrders();
  }

  public async getStoreTeams(): Promise<void> {
    try {
      this.teamLoading = true;
      const teams = await teamService.getTeamsSelect(this.filters);
      this.storeTeams = teams.results;
      if (!this.filters) {
        this.selectedFilter = this.storeTeams
          .filter((f) => {
            return f.selected;
          })
          .map((m) => m.id);
      } else {
        this.selectedFilter = this.filters.split(',');
      }
    } finally {
      this.teamLoading = false;
    }
    // this.getopenOrders();
  }
  public async getopenOrders(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const response = await repairOrderService.getOpenRepairOrders(
        this.pagination,
        this.filters
      );
      const result = response;
      this.pagedRepairOrders.isAdvisorRole = result.isAdvisorRole;
      this.pagedRepairOrders.isMessagingEnabled = result.isMessagingEnabled;
      this.pagedRepairOrders.showCallDetails = result.showCallDetails;
      this.pagedRepairOrders.storeLogo = result.storeLogo;
      this.pagedRepairOrders.storeName = result.storeName;
      this.pagedRepairOrders.results = result.results;

      this.pagination.totalItems = result.results.length;
    } finally {
      this.pagination = this.currentRoutePagination;
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, paging);
    if (queryStringObj) {
      queryStringObj.filters = this.filters;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
  }

  public ChangeTriggered(paging: any) {
    this.pagination = paging;
  }
  public rowsPerPage(rowsPerpage): void {
    if (rowsPerpage !== this.pagination.rowsPerPage) {
      this.pagination.rowsPerPage = rowsPerpage;
      this.pagination.page = 1;
      this.updatePaging(this.pagination);
    }
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const result = await depositLogService.getDefaultPaymentProvider(
        this.userSession.storeId
      );
      this.paymentProvider = result.paymentProvider;
      this.storeId = result.storeId;
      this.tenantId = result.tenantId;
      this.enterpriseId = result.enterpriseId;
      this.storeName = result.storeName;
      this.isCenposConfigured = result.isCenposConfigured;
      this.isSquareConfigured = result.isSquareConfigured;
      this.isCloverConfigured = result.isCloverConfigured;
      this.isTerminalPaymentEnabled = result.isTerminalPaymentEnabled;

      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
    } finally {
      // finally block
    }
  }

  public async getLanes(): Promise<void> {
    try {
      this.isLaneLoading = true;
      const response = await await laneService.getLanesAsync();
      this.getSelectedLaneList = response.results;
      this.lane = "";
    } finally {
      this.isLaneLoading = false;
    }
  }

  public async getRoDetail(roNumber): Promise<void> {
    try {
      this.paymentAmountDialog.action.disable = true;
      this.paymentAmountDialog.loading = true;
      const response = await repairOrderService.getOpenClosRoDetail(roNumber);
      this.roDetails = response;
      this.confirmPaymentDialog();
    } catch {
      this.paymentAmountDialog.action.disable = false;
      this.paymentAmountDialog.loading = false;
      this.paymentAmountDialog.model = false;
      this.closeRoPaymentDetail = {};
    } finally {
      // finally block
    }
  }

  public paymentOptions: IPaymentDialog = {
    id: "RoPaymentList",
    url: window.location.href,
    customerKey: this.roDetails.customerKey,
    vin: this.roDetails.vin,
    amount: Number(this.closeRoPaymentDetail.amountToBePaid),
    address: this.roDetails.customerStreetAddress1 + ' ' + this.roDetails.customerStreetAddress2,
    city: this.roDetails.customerCity,
    state: this.roDetails.customerState,
    zipcode: this.roDetails.customerZip,
    customerEmail: this.roDetails.customerEmail1,
    merchantEmail: this.roDetails.merchantEmail,
    recordKey: this.roDetails.roNumber,
    isAmountOverride: this.isAmountOverride,
    recordIdentifier: "RO",
    type: "0",
    isSendPaymentReceipt: this.isSendPaymentReceipt,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    bypassReason: this.bypassReason

  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
export default RepairOrderListPage;
